import * as React from "react";
const SvgTTag = props => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="#F2A043" viewBox="0 0 16 16" {...props}><circle cx={8} cy={8} r={8} fill="auto" /><path fill="#fff" d="M11.385 4.395H8.643V12h-1.12V4.395H4.787v-.926h6.598z" /></svg>;
export default SvgTTag;